import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

// Custom CSS
import "./scss/main.scss";

// Pages
import Home from "./pages/Home";
import Test from "./pages/Test";
import ContactForm from "./components/ContactForm/ContactForm";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import AboutUs from "./pages/AboutUs";
import EducationalOffer from "./pages/EducationalOffer";
import Research from "./pages/Research";
import InstitutionalServices from "./pages/InstitutionalServices";
import Contact from "./pages/Contact";
import Events from "./pages/Events";
import CourseDetail from "./pages/CourseDetail";
import PostGraduates from "./pages/PostGraduates";
import PostGraduatesDetail from "./pages/PostGraduatesDetail";
import NotFound from "./pages/NotFound";

const AppContent = () => {
  const location = useLocation();

  // console.log(location.pathname);

  // List of known static routes
  const knownRoutes = [
    "/",
    "/acerca-de",
    "/oferta-educativa",
    "/servicios-institucionales",
    "/investigacion-e-innovacion-educativa",
    "/maestrias",
    "/contacto",
    "/eventos",
  ];

  // Function to check if the current path matches known static routes
  const isKnownRoute = knownRoutes.includes(location.pathname);

  // console.log(isKnownRoute);

  // Function to check if the current path matches dynamic routes
  const isDynamicRoute =
    /^\/oferta-educativa\/\d+$/.test(location.pathname) ||
    /^\/maestrias\/\d+$/.test(location.pathname);
  // console.log(isDynamicRoute);

  // Determine if the path is "Not Found"
  const isNotFound = !isKnownRoute && !isDynamicRoute;

  // console.log(isNotFound);
  return (
    <>
      <main>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/acerca-de">
            <AboutUs />
          </Route>
          <Route exact path="/contacto">
            <Contact />
          </Route>
          <Route exact path="/eventos">
            <Events />
          </Route>
          <Route exact path="/oferta-educativa">
            <EducationalOffer />
          </Route>
          <Route exact path="/maestrias">
            <PostGraduates />
          </Route>
          <Route exact path="/maestrias/:id">
            <PostGraduatesDetail />
          </Route>
          <Route exact path="/oferta-educativa/:id">
            <CourseDetail />
          </Route>
          <Route exact path="/investigacion-e-innovacion-educativa">
            <Research />
          </Route>
          <Route exact path="/servicios-institucionales">
            <InstitutionalServices />
          </Route>
          {/* <Route exact path="/test">
            <Test />
          </Route> */}
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </main>
      {!isNotFound && <ContactForm />}
      {!isNotFound && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
